import { useState } from "react";
import SvgCheckBox from "./SvgCheckBox";
import TermsModal from "./TermsModal";
import { useTranslation } from "@/hooks/localization/useTranslations";
// const TermsModal = dynamic(() => import("./TermsModal"), { ssr: false });

interface Props {
  checked: boolean;
  setChecked: (checked: boolean) => void;
  terms: string;
  primaryInnerColor?: boolean;
}
const AgreeTermsCheckbox: React.FC<Props> = ({
  terms,
  checked,
  setChecked,
  primaryInnerColor,
}) => {
  const t = useTranslation();
  const [showTerms, setShowTerms] = useState(false);
  return (
    <>
      {showTerms && (
        <TermsModal
          show={showTerms}
          setShow={setShowTerms}
          setAgree={setChecked}
          terms={terms}
        />
      )}
      <div
        className={`consult-checkbox ${
          primaryInnerColor ? "primary-inner-color" : ""
        }`}
      >
        <div onClick={() => setChecked(!checked)}>
          <SvgCheckBox
            checked={checked}
            primaryInnerColor={primaryInnerColor}
          />
        </div>
        <div className="text-nowrap">
          <bdi>{t.i_agree_to}</bdi>
          <span
            className={`consult-link ${
              primaryInnerColor ? "primary-inner-color" : ""
            }`}
            onClick={(e) => {
              e.stopPropagation();
              setShowTerms(true);
            }}
          >
            {t.terms_conditions}
          </span>
        </div>
      </div>
    </>
  );
};

export default AgreeTermsCheckbox;
